module.exports = __webpack_public_path__ + "static/media/bullseye-pointer.79716466.svg";